import { Table } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { getResearchPerfEvalCriteriaOptions } from '@/module/ResearchPerfEval/model/ResearchPerfEvalQuery';

import { Content } from '@/core/components';

import { Id } from '@feature/utils';

interface ResearchPerfEvalCriteriaTableProps {
  evaluationId: Id;
}

export function ResearchPerfEvalCriteriaTable({ evaluationId }: ResearchPerfEvalCriteriaTableProps) {
  const { data } = useSuspenseQuery(getResearchPerfEvalCriteriaOptions(evaluationId));
  const { t } = useTranslation();

  return (
    <Content>
      <Table
        style={{ borderRadius: '12px' }}
        striped
        highlightOnHover
        withTableBorder
        withColumnBorders
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th>{t('researchPerfEval.table.index')}</Table.Th>
            <Table.Th>{t('researchPerfEval.table.title')}</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {data.map(criteria => (
            <Table.Tr key={criteria.orderNo}>
              <Table.Td>
                <Link
                  to="/research-perf-eval/$evaluationId/report/gather/$orderNo"
                  params={{ evaluationId: String(evaluationId), orderNo: String(criteria.orderNo) }}
                >
                  {criteria.orderNo}
                </Link>
              </Table.Td>
              <Table.Td>{criteria.title}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Content>
  );
}
